var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.statuses.length
      ? _c("div", [
          _vm._v(
            "\n        " +
              _vm._s(_vm.statuses[0].registrationAuthority.name) +
              ":\n        "
          ),
          _c("em", [_vm._v(_vm._s(_vm.statuses[0].stateName))]),
          _vm._v(
            " on\n        " +
              _vm._s(_vm.getPrettyDate(_vm.statuses[0].registrationDate)) +
              "\n    "
          ),
        ])
      : _c("div", [_vm._v("\n        Unregistered\n    ")]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }